import { useEffect, useRef } from 'react';
import socketService from '../services/socketService';
import { AssessmentType } from '../services/assessmentService';

export const useTranscribedEvent = (
  conversationId: string | null,
  userName: string,
  assessment: AssessmentType,
  onTranscript: (text: string, speaker: string) => void,
  onSpeaking: (who: string | null) => void,
  setMicEnabled: (b: boolean) => void,
  setBlockMic: (b: boolean) => void
) => {
  const onSpeakingRef = useRef(onSpeaking);

  useEffect(() => { onSpeakingRef.current = onSpeaking; }, [onSpeaking]);

  useEffect(() => {
    const handleTranscript = (data: { text: string, activeSocketId: string }) => {
      console.log('[Transcription] Recieved transcript of "' + data.text + '"')
      setBlockMic(true);
      setMicEnabled(false);
      onTranscript(data.text, userName);
      onSpeakingRef.current(null);
      socketService.sendMessageWithTts(data.text, conversationId, true, assessment.id);
    };
    socketService.socket?.on('transcript', handleTranscript);
    return () => {
      socketService.socket?.off('transcript', handleTranscript);
    };
  }, [conversationId, userName, onTranscript, setMicEnabled, setBlockMic, assessment.id]);
};